import request from '@/utils/request'

export function getFavorites() {
    return request({ url: '/api/wms/user/favorites', method: 'get' })
}

export function addFavorite(permissionId) {
    return request({ url: '/api/wms/user/favorites', method: 'post', data: { permissionId } })
}

export function removeFavorite(permissionId) {
    return request({ url: `/api/wms/user/favorites/${permissionId}`, method: 'delete' })
}
